import { render } from "./ContactSocialMedia.vue?vue&type=template&id=fb05e430&scoped=true&ts=true"
import script from "./ContactSocialMedia.vue?vue&type=script&lang=ts"
export * from "./ContactSocialMedia.vue?vue&type=script&lang=ts"

import "./ContactSocialMedia.vue?vue&type=style&index=0&id=fb05e430&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb05e430"]])

export default __exports__